import InviteMember from './InviteMember.component';

export default InviteMember;
